import { MatSort } from '@angular/material/sort';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryCompany } from '../models/RepositoryCompany';
import { MainService } from '../services/delavci/main.service';
import { RepositoryService } from '../services/repository.service';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrls: ['./repository.component.css']
})
export class RepositoryComponent implements OnInit {

  public listOfCompanies: Array<RepositoryCompany> = [];
  public listOfGroupedCompanies: Array<{code, id, nameSmall}> = [];
  public listOfModules: Array<{modulCode, modulId, modulNameSmall, serverCode, serverDescriptionLarge, serverAddressInternal, serverDbPort, serverAddress}> = [];
  public selectedCompanies: {code, id, nameSmall};
  public selectedModules;
  public spinner;
  public showFilter;
  constructor(private repositoryService: RepositoryService, private mainService: MainService, private router: Router) { }

  ngOnInit() {
    this.mainService.odlagalisceFilterBool.subscribe( bool => {
      this.showFilter = bool;
    });

    this.repositoryService.getCompanies().subscribe( data =>{
      this.listOfCompanies = data.data.companies;
      this.extractCompanies(this.listOfCompanies);
    }, error => {
      console.log(error);
    });

    this.repositoryService.currentRepositoryCompany.subscribe( company=> {
      if(company != undefined) {
        this.selectedCompanies = company;
      }
    });
  }


  extractCompanies(companies: Array<RepositoryCompany>) {
    this.listOfGroupedCompanies = [];
    companies.forEach(element => {
      if(!this.listOfGroupedCompanies.some(company => company.id === element.id)){
        this.listOfGroupedCompanies.push({nameSmall: element.nameSmall, id: element.id, code: element.code});
      }
    });
    if(this.selectedCompanies) {
      for(let i = 0; i < this.listOfGroupedCompanies.length; i++) {
        if(this.listOfGroupedCompanies[i].id === this.selectedCompanies.id) {
          this.extractModules(this.listOfGroupedCompanies[i]);
        }
      }
    } else {
      this.extractModules(this.listOfGroupedCompanies[0]);
    }
  }

  extractModules(company) {
    //this.selectedCompanies= company;
    this.repositoryService.changeRepositoryCompany(company);
    this.listOfModules = [];
    for(let i = 0; i < this.listOfCompanies.length; i++) {
      if(this.listOfCompanies[i].id === company.id) {
        this.listOfModules.push({modulCode: this.listOfCompanies[i].modulCode, modulId: this.listOfCompanies[i].modulId, modulNameSmall: this.listOfCompanies[i].modulNameSmall,
          serverCode: this.listOfCompanies[i].serverCode, serverDescriptionLarge: this.listOfCompanies[i].serverDescriptionLarge,
           serverAddressInternal: this.listOfCompanies[i].serverAddressInternal, serverDbPort: this.listOfCompanies[i].serverDbPort,
           serverAddress: this.listOfCompanies[i].serverAddress});
      }
    }
    this.sortByABC();
  }

  //sortiraj listOfModules po abecedi
  sortByABC() {
    this.listOfModules.sort(function(a, b){
      if(a.modulNameSmall < b.modulNameSmall) { return -1; }
      if(a.modulNameSmall > b.modulNameSmall) { return 1; }
      return 0;
    });
  }

  rerouter(module) {
    switch(module.modulNameSmall) {
      case 'Lumina POS': {
        this.router.navigate(['/odlagalisce/podrobno-lumina-POS'], {queryParams: {modulId: module.modulId, modulNameSmall: module.modulNameSmall,
          serverCode: module.serverCode, companyId: this.selectedCompanies.id}});
         break;
      }
      case 'BO_SERVER': {
         //this.repositoryService.changeServerParameters(module.serverDescriptionLarge);  this.router.navigate(['/odlagalisce/podrobno-server']);
         this.router.navigate(['/odlagalisce/podrobno-server'], {queryParams: {modulId: module.modulId, companyId: this.selectedCompanies.id}});
         break;
      }
      case 'DATABASE': {
        break;
     }
   }
  }


}
